import { memberId } from '@trello/session-cookie';
import { PersistentSharedState } from '@trello/shared-state';

interface WorkspaceNavigationState {
  expanded: boolean;
  enabled: boolean;
}

export const workspaceNavigationState = new PersistentSharedState<WorkspaceNavigationState>(
  { expanded: false, enabled: false },
  `workspaceNavigation-${memberId ?? 'anonymous'}`,
);
